import { Component } from "react"
import PropTypes from "prop-types"
import sluggify from "shared/lib/sluggify"
import ingredientValidator from "./ingredient_validator"
import displayFlash from "partners/scripts/display_flash"
import isEmpty from "lodash/isEmpty"

import * as $ from "jquery"

export default class IngredientForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: this.props.name,
      slug: this.props.slug,
      note: this.props.note,
      value_type: this.props.value_type || "string",
      example: this.props.example,
      errors: {},
    }

    this.onSlugFocus = this.onSlugFocus.bind(this)
    this.onNameChange = this.onNameChange.bind(this)
    this.onNameFocus = this.onNameFocus.bind(this)
    this.onNameBlur = this.onNameBlur.bind(this)
    this.onSlugChange = this.onSlugChange.bind(this)
    this.onValueTypeChange = this.onValueTypeChange.bind(this)
    this.onExampleChange = this.onExampleChange.bind(this)
    this.saveIngredient = this.saveIngredient.bind(this)
    this.onNoteChange = this.onNoteChange.bind(this)
    this.deleteIngredient = this.deleteIngredient.bind(this)
    this.hideIfFeedTrigger = this.hideIfFeedTrigger.bind(this)
  }

  onSlugChange(event) {
    this.setState({ slug: event.target.value })
  }

  onSlugFocus() {
    if (this.state.slug === undefined && this.state.name !== undefined) {
      this.setState({ slug: sluggify(this.state.name) })
    }
  }

  onNameFocus() {
    if (this.state.name !== undefined) {
      this.setState({ name: sluggify(this.state.name, "Camel") })
    }
  }

  onNameBlur() {
    this.setState({ name: sluggify(this.state.name, "Camel") })
  }

  onNameChange(event) {
    this.setState({ name: event.target.value })
  }

  onValueTypeChange(event) {
    this.setState({ value_type: event.target.value })
  }

  onExampleChange(event) {
    this.setState({ example: event.target.value })
  }

  onNoteChange(event) {
    this.setState({ note: event.target.value })
  }

  parseErrors(errors) {
    let _errors = {}
    errors.forEach(error => {
      return (_errors[error.attribute] = error.message)
    })
    this.setState({ errors: _errors })
  }

  saveIngredient(event) {
    event.preventDefault()

    let _errors = ingredientValidator(this.state)
    this.setState({ errors: _errors })

    if (!isEmpty(_errors)) {
      return
    }

    let url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/ingredients`
    let verb = "created"
    let method = "POST"

    if (this.props.id !== undefined) {
      url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/ingredients/${this.props.slug}`
      method = "PUT"
      verb = "updated"
    }

    $.ajax({
      url,
      data: $(".ingredient-form").serializeArray(),
      cache: false,
      processData: true,
      type: method,
      success() {
        displayFlash(`Ingredient ${verb}`)
      },
      error: function (response) {
        try {
          const errors = JSON.parse(response.responseText).errors
          displayFlash("There has been an error saving the Ingredient", "error")
          this.parseErrors(errors)
        } catch (err) {
          displayFlash("There has been an error saving the Ingredient", "error")
        }
      }.bind(this),
    })
  }

  deleteIngredient(event) {
    event.preventDefault()

    let url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/ingredients/${this.props.slug}`
    url +=
      `?authenticity_token=` +
      window.encodeURIComponent(this.props.authenticity_token)

    const confirm = window.confirm(
      "Are you sure you want to PERMANENTLY delete this Ingredient?"
    )

    if (confirm) {
      $.ajax({
        url,
        cache: false,
        type: "DELETE",
        success() {
          displayFlash("Ingredient deleted")
        },
        error: function () {
          try {
            displayFlash(
              "There has been an error deleting the Ingredient.",
              "error"
            )
          } catch (err) {
            displayFlash(
              "There has been an error deleting the Ingredient.",
              "error"
            )
          }
        }.bind(this),
      })
    }
  }

  displayError(str) {
    return <span className="error-message">Error: {str}</span>
  }

  extraField() {
    if (
      this.state.value_type !== undefined &&
      this.state.value_type.indexOf("date") == -1
    ) {
      return (
        <div className="field">
          <div className="label">
            <label htmlFor="partner_trigger_ingredient_example">Example</label>
          </div>
          <div className="input">
            <input
              type="text"
              name="partner_trigger_ingredient[example]"
              id="partner_trigger_ingredient_example"
              value={this.state.example}
              onChange={this.onExampleChange}
              placeholder="E.g. https://yourwebpage.com/profile/album/1234.jpg"
            />
          </div>
          <p className="note">
            Example of ingredient in action
            {this.state.errors.example
              ? this.displayError(this.state.errors.example)
              : ""}
          </p>
        </div>
      )
    }
  }

  option(fieldType) {
    return (
      <option key={fieldType.value} value={fieldType.value}>
        {fieldType.name}
      </option>
    )
  }

  ingredientOptions() {
    const options = this.props.field_types.map(fieldType =>
      this.option(fieldType)
    )
    return (
      <select
        name="partner_trigger_ingredient[value_type]"
        onChange={this.onValueTypeChange}
        defaultValue={this.props.value_type}
      >
        {options}
      </select>
    )
  }

  hideIfFeedTrigger(content) {
    return this.props.is_feed_trigger ? null : content
  }

  render() {
    return (
      <form className="service-edit form ingredient-form">
        <section>
          <div className="fieldset trigger-ingredients list-item-form">
            <div className="field">
              <div className="label">
                <label htmlFor="partner_trigger_ingredient_name">Name</label>
              </div>
              <div className="input">
                <input
                  type="text"
                  name="partner_trigger_ingredient[name]"
                  id="partner_trigger_ingredient_name"
                  value={this.state.name}
                  onChange={this.onNameChange}
                  onFocus={this.onNameFocus}
                  onBlur={this.onNameBlur}
                />
              </div>
              <p className="note">
                in UpperCamelCase
                {this.state.errors.name
                  ? this.displayError(this.state.errors.name)
                  : ""}
              </p>
            </div>

            {this.hideIfFeedTrigger(
              <div className="field">
                <div className="label">
                  <label htmlFor="partner_trigger_ingredient_slug">Slug</label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    name="partner_trigger_ingredient[slug]"
                    id="partner_trigger_ingredient_slug"
                    value={this.state.slug}
                    onChange={this.onSlugChange}
                    onFocus={this.onSlugFocus}
                  />
                </div>
                <p className="note">
                  in snake_case
                  {this.state.errors.slug
                    ? this.displayError(this.state.errors.slug)
                    : ""}
                </p>
              </div>
            )}

            <div className="field">
              <div className="label">
                <label htmlFor="partner_trigger_ingredient_note">Note</label>
              </div>
              <div className="input">
                <input
                  type="text"
                  name="partner_trigger_ingredient[note]"
                  id="partner_trigger_ingredient_note"
                  value={this.state.note}
                  onChange={this.onNoteChange}
                />
              </div>

              <p className="note">
                Must be a complete sentence
                {this.state.errors.note
                  ? this.displayError(this.state.errors.note)
                  : ""}
              </p>
            </div>

            {this.hideIfFeedTrigger(
              <div className="field">
                <div className="label">
                  <label htmlFor="partner_trigger_ingredient_value_type">
                    Type
                  </label>
                </div>
                <div className="input">{this.ingredientOptions()}</div>
              </div>
            )}

            {this.extraField()}

            <input
              type="hidden"
              name="partner_trigger_ingredient[trigger_id]"
              id="partner_trigger_ingredient_trigger_id"
              value={this.props.trigger_id}
            />

            <input
              type="hidden"
              name="authenticity_token"
              value={this.props.authenticity_token}
            />

            <div className="actions">
              {this.props.platformUnpublished && this.props.id && (
                <div className="action-left">
                  <a
                    href=""
                    className="secondary-action delete"
                    onClick={this.deleteIngredient}
                  >
                    Delete
                  </a>
                </div>
              )}
              <div className="action-right">
                <a
                  role="button"
                  className="button-secondary button-cancel-link"
                  data-action="cancel-form"
                  data-load-form-async="ingredients"
                >
                  Cancel
                </a>
                <button
                  className="button-secondary"
                  onClick={this.saveIngredient}
                  data-disable-with="Saving…"
                  disabled={!this.props.platformUnpublished}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>
    )
  }
}

IngredientForm.propTypes = {
  authenticity_token: PropTypes.string.isRequired,
  name: PropTypes.string,
  slug: PropTypes.string,
  service_slug: PropTypes.string.isRequired,
  trigger_id: PropTypes.number.isRequired,
  is_feed_trigger: PropTypes.bool.isRequired,
  id: PropTypes.number,
  label: PropTypes.string,
  note: PropTypes.string,
  value_type: PropTypes.string,
  example: PropTypes.string,
  field_types: PropTypes.array.isRequired,
  platformUnpublished: PropTypes.bool.isRequired,
}
